import LMSDispatcher from "../../LMSDispatcher";
import { EventEmitter } from "events";

import * as CONSTANTS from "../../../utilities/Constants";
import { IActionHeaderEditData } from "../../../models/shared/ActionHeaderData";


interface IActionHeaderCommonState {
    state: IActionHeaderEditData
}

class ActionHeaderEditStore extends EventEmitter implements IActionHeaderCommonState {
    state: IActionHeaderEditData

    constructor() {

        super();

        this.state = {
            moduleName: "",
            editData: {},
            deleteId: "",
            deleteMessage: "",
            deleteRequestId: "",
            deleteTitle: ""
        };

        LMSDispatcher.register((e: any) => {
            switch (e.type) {
                case CONSTANTS.EDIT:
                    
                    Object.assign(this.state, e.payload);
                    this.emit('change', this.state);
                    break;
            }
        });
    }
}
const actionHeaderEditStore = new ActionHeaderEditStore();

export default actionHeaderEditStore;
